import { Step } from 'src/app/_services/types/step.type';

import { BUSINESS_INSURANCE_FUNNEL_EVENT_BASE } from '../company-insurance-constants';

export const BUSINESS_BASIC_FLOW_STEPS: {
  BASIC_FORM: Step;
  OFFERS: Step;
  LOGIN: Step;
  REGISTER: Step;
  END: Step;
} = {
  BASIC_FORM: {
    step: [1, 1],
    url: 'informations',
    datalayerEvent: {
      ...BUSINESS_INSURANCE_FUNNEL_EVENT_BASE,
      funnel_stage: 1,
      stage_name: 'Informations',
    },
  },
  OFFERS: {
    step: [2, 1],
    url: 'offres',
    datalayerEvent: {
      ...BUSINESS_INSURANCE_FUNNEL_EVENT_BASE,
      funnel_stage: 2,
      stage_name: 'Offres',
    },
  },
  LOGIN: {
    step: [2, 1],
    url: 'connexion',
    datalayerEvent: {
      ...BUSINESS_INSURANCE_FUNNEL_EVENT_BASE,
      funnel_stage: 4,
      stage_name: 'Connexion',
    },
  },
  REGISTER: {
    step: [2, 1],
    url: 'inscription',
    datalayerEvent: {
      ...BUSINESS_INSURANCE_FUNNEL_EVENT_BASE,
      funnel_stage: 4,
      stage_name: 'Inscription',
    },
  },
  END: {
    step: [3, 1],
    url: 'fin',
    datalayerEvent: {
      ...BUSINESS_INSURANCE_FUNNEL_EVENT_BASE,
      funnel_stage: 5,
      stage_name: 'Fin',
      funnel_complete: true,
    },
  },
};
